import { gql } from "@apollo/client";

export default gql`
  query getReportYears {
    getReportYears {
      id
      reportyear
    }
  }
`;
